import React, { useState } from 'react';
import { Container, Row, Card, Col, Form, Spinner, Button, Modal, Table } from 'react-bootstrap';
import { useEffect } from 'react';
import { WidgetsOutlined, Add, OpenInNew } from '@material-ui/icons';
import ProviderRequestService from 'services/provider-request';
import { Trans } from 'react-i18next';
import Pagination from 'react-js-pagination';
import Can from 'components/Can';
import { useHistory } from 'react-router-dom'
import Alert from '../../helpers/alert';

import './style.css';
import Swal from 'sweetalert2';
import { useCompany } from 'models';

export default function () {
  const history = useHistory()
  const { company: currentCompany } = useCompany()

  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  //const [currentCompany] = useState(JSON.parse(localStorage.getItem('currentCompany')));

  const [companies, setCompanies] = useState([]);
  const [__search, setSearch] = useState('');
  const [pagination, setPagination] = useState({});
  const [load, setLoad] = useState(false);
  const [showModalInfoProvider, setShowModalInfoProvider] = useState(false)
  const [provider, setProvider] = useState({})

  const defaultFilters = { per_page: 20, page: 1 };
  const [filters, setFilters] = useState(defaultFilters);
  const minWidth = 370;
  const isMobile = window.innerWidth < minWidth;
  useEffect(() => {
    connect(__search);
  }, [__search])

  const connect = (__search) => {
    setLoad(true)
    ProviderRequestService.index({
      params: {
        __search: __search,
        ...filters,
        __company_id: currentCompany ? currentCompany.id : null
      }
    }).then(data => {
      setPagination(data.data.pagination);
      setCompanies(data.data.data.map(a => {
        a.img = a.url_image_logo;
        return a;
      }));
      setLoad(false);
    });
  }

  const isLoading = () => {
    return load.length > 0;
  }

  const handleClose = () => setShowModalInfoProvider(false)

  const createCard = (company) => {
    return (
      <Card className="h-100" style={{ cursor: 'pointer' }}>
        <Card.Body
          className="h-100 shadow"
          onClick={a => {
            setProvider(company)
            setShowModalInfoProvider(true)
          }}
        >
          <Row className="h-100">
            <Col className="align-items-center align-self-center">
              {company.img ? (
                <img src={company.img} className="w-75"></img>
              ) :
                company.name
              }
            </Col>
          </Row>
        </Card.Body>
      </Card>
    )
  };

  const createList = (companies) => {
    return companies.map((a, k) => {
      return (
        <Col md='3' key={k} className="pb-3" style={{ height: '220px' }}>{createCard(a)}</Col>
      )
    });
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const handlePageChange = (page) => handleFilterChange({ page });

  const handleInactivate = id => {
    Alert.warning({
      preConfirm: () => {
        Swal.showLoading()
      }
    })
      .then((result) => {
        if (result.isConfirmed) {
          ProviderRequestService.delete(id)
            .then(() => {
              Swal.fire('Sucesso', 'Fornecedor inativado.', 'success')
              setShowModalInfoProvider(false)
              connect()
            })
        }
      });
  }

  return (
    <>
      <Container className="mb-5">
        <Row className="col-12 mt-4 row">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Fornecedores</h5>
        </Row>
        <Row>
          <Col className="col-12 d-flex justify-content-center my-3">
            <Card.Body className="shadow bg-white rounded text-center pt-3">
              <Can do="providers.edit" on="App">
                <Row className="col-12 mt-2 mb-5">
                  <Button className="btn-add" href={'/master-agent/provider/edit'}>
                    <Add /> Cadastrar Fornecedor
                  </Button>
                </Row>
              </Can>
              <Row>
                <Col md="auto" className="text-left">
                  <Form.Group>
                    <Form.Label>Pesquisa</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) =>
                        setSearch(e.target.value)
                      }
                    />
                    <div className="load-search" style={{ display: load ? 'block' : 'none' }}>
                      <Spinner animation="border" style={{ color: '#e05c17' }} size="sm" />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <br />
              <Row>
                {createList(companies)}
              </Row>
              <Row>
                <Col xs="12" md="6" className="text-left">
                  <Trans i18nKey="label:interpolateShowingRecords">
                    Showing {{ from: pagination.from || '0' }} to{' '}
                    {{ to: pagination.to || '0' }} from{' '}
                    {{ total: pagination.total }} records
                  </Trans>
                </Col>
                <Col xs="12" md="6" className="d-flex justify-content-end">
                  <Pagination
                    activePage={parseInt(pagination.current_page)}
                    itemsCountPerPage={parseInt(pagination.per_page)}
                    totalItemsCount={parseInt(pagination.total)}
                    pageRangeDisplayed={isMobile ? 3 : 5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                    prevPageText="‹"
                    nextPageText="›"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Col>
        </Row>

        <Modal
          show={showModalInfoProvider && provider.hasOwnProperty('id')}
          onHide={handleClose}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>              
              <p >{provider.name}</p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md="auto" className='mb-3'>
                <img width="150" src={provider.img} />
              </Col>
              <Col md="12">
                <Table striped bordered>
                  <thead>
                    <th>Nome</th>
                    <th>Categoria</th>
                    <th></th>
                  </thead>
                  <tbody>
                    {provider.hasOwnProperty('id') ? (<>
                      {provider.documents.map(doc => {
                        return (
                          <tr>
                            <td>{doc.name}</td>
                            <td>{doc.category.name}</td>
                            <td>
                              <a href={doc.url_document} target="_blank">
                                <OpenInNew />
                              </a>
                            </td>
                          </tr>
                        )
                      })}
                    </>) : (<></>)}
                  </tbody>
                </Table>
              </Col>
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={() => {
              history.push('/master-agent/provider/edit/' + provider.id)
            }}>
              Editar
            </Button>
            <Can do="providers.delete" on="App">
              <Button variant="danger" onClick={() => {
                handleInactivate(provider.id)
              }}>
                Inativar
              </Button>
            </Can>
          </Modal.Footer>
        </Modal>

      </Container>
    </>
  );
}